(function () {
    "use strict";

    function addAuthToken(currentUser, $q, URL) {

        var vm = this;

        vm.request = request;

        var isAuthEndpointRequest = function (url) {
            var urlSplit = url.split(URL.URL);
          
            if (urlSplit[1] != null) {
               return urlSplit[1].slice(0, "/auth".length) === "/auth";
            }
            return false;
        };

        function request(config) {
            if (isAuthEndpointRequest(config.url) === false && currentUser.profile.loggedIn) {
                config.headers.Authorization = "Bearer " + currentUser.profile.token;
            }
            return $q.when(config);
        }
    }

    addAuthToken.$inject = ["sphForms.currentUser", "$q","URL"];

    angular.module("sphForms.auth")
        .service("sphForms.addAuthToken", addAuthToken);

})();
